import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Stack } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { usePermissions } from '../../context/PermissionsContext';
import { useAuth } from '../../context/AuthContext';

const NoAutorizado: React.FC = () => {
  const navigate = useNavigate();
  const { modulos } = usePermissions();
  const { logout } = useAuth();

  // Ir al primer módulo disponible; si no hay ninguno, logout
  const handleGoBack = () => {
    if (modulos.length > 0) {
      navigate(modulos[0]);
    } else {
      logout();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
        textAlign: 'center',
        px: 3,
      }}
    >
      <LockOutlinedIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
      <Typography variant="h4" fontWeight={600}>
        Acceso no autorizado
      </Typography>
      <Typography variant="body1" color="text.secondary" maxWidth={400}>
        No tienes permisos para acceder a este módulo. Contacta al administrador si crees que esto es un error.
      </Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="contained" onClick={handleGoBack}>
          {modulos.length > 0 ? 'Ir al inicio' : 'Cerrar sesión'}
        </Button>
      </Stack>
    </Box>
  );
};

export default NoAutorizado;
